import {
  Component,
  ElementRef,
  EventEmitter,
  Output,
  ViewChild,
} from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { CoreService } from '../../core.service';
import { AuthService } from '../../../../services/auth/auth.service';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss'],
})
export class SideMenuComponent {
  @Output() itemClick = new EventEmitter();
  @Output() showPatientCreateDialog = new EventEmitter();

  previoulsySelectedModule = null;
  currentRoute = '';

  token$ = this.authService.token$;
  roles: string | undefined = '';

  items: MenuItem[] = [];
  subscriptions: Subscription[] = [];
  constructor(
    private readonly router: Router,
    private readonly coreService: CoreService,
    private readonly authService: AuthService
  ) {}

  ngOnInit(): void {
    this.subscriptions = [
      this.router.events.subscribe((event: any) => {
        event instanceof NavigationEnd ? (this.currentRoute = event.url) : null;
        if (!this.currentRoute && event.routerEvent instanceof NavigationEnd) {
          this.currentRoute = event.routerEvent.url;
        }
        this.items = this.generateMenuItems();
      }),
    ];

    this.token$.subscribe((t) => {
      this.roles = t?.role;
      this.items = this.generateMenuItems();
    });
  }

  handleModuleClick(data: any) {
    if (this.previoulsySelectedModule != undefined) {
      (this.previoulsySelectedModule as any).style = {};
      this.previoulsySelectedModule = data;
    }
  }

  menuItem(options: {
    label: string;
    icon: string;
    routerLink?: string;
    url?: string;
    command?: any;
    roles: string[];
  }): MenuItem {
    return {
      label: options.label,
      icon: `pi pi-pw ${options.icon}`,
      routerLink: options.routerLink,
      url: options.url,
      command: () => {
        if (options.command) options.command();
        this.itemClick.emit();
      },
      visible:
        options.roles?.length > 0
          ? this.authService.hasRoles(options.roles)
          : true,
      routerLinkActiveOptions: { exact: true },
      styleClass: `${
        this.currentRoute === options.routerLink ? 'selected' : ''
      }`,
    };
  }

  generateMenuItems(): MenuItem[] {
    return [
      {
        label: 'Λειτουργίες',
        expanded: true,
        items: [
          this.menuItem({
            label: 'Αρχική',
            icon: 'pi pi-pw pi-home',
            routerLink: '/home',
            roles: [],
          }),
          this.menuItem({
            label: 'Χρήστες',
            icon: 'pi pi-user',
            routerLink: '/user/search',
            roles: ['Admin'],
          }),
          this.menuItem({
            label: 'Κλινικές',
            icon: 'pi pi-warehouse',
            routerLink: '/clinic/search',
            roles: ['Admin'],
          }),
          this.menuItem({
            label: 'Ενιαία Λίστα Χειρουργείων',
            icon: 'fa fa-heartbeat',
            routerLink: '/surgeries-idika/list',
            roles: ['EkapyAdmin'],
          }),
          this.menuItem({
            label: 'Ανατεθειμένα Χειρουργεία',
            icon: 'fa fa-hospital-o',
            routerLink: '/surgeries-assigned/list',
            roles: ['HospitalAdmin', 'ClinicAdmin'],
          }),
          this.menuItem({
            label: 'Λίστα Χειρουργείων',
            icon: 'fa fa-hospital-o',
            routerLink: '/surgeries-assigned/list',
            roles: ['ViewOnly'],
          }),
          this.menuItem({
            label: 'Παραλαβή Χειρουργείου',
            icon: 'fa fa-medkit',
            routerLink: '/surgery/receive',
            roles: ['PrivateHospitalAdmin', 'PrivateClinicAdmin'],
          }),
          this.menuItem({
            label: 'Λίστα Ιδιωτικής Δομής',
            icon: 'fa fa-hospital-o',
            routerLink: '/surgeries-assigned/list',
            roles: ['PrivateHospitalAdmin', 'PrivateClinicAdmin'],
          }),
          this.menuItem({
            label: 'Λίστα προς ιδιωτική δομή',
            icon: 'fa fa-h-square',
            routerLink: '/surgeries-private/list',
            roles: ['HospitalAdmin', 'ClinicAdmin'],
          }),
          this.menuItem({
            label: 'Λίστα Χειρουργείων',
            icon: 'fa fa-hospital-o',
            routerLink: '/surgeries-citizen/list',
            roles: ['Citizen'],
          }),
        ],
      },

      {
        label: 'Διαχείριση',
        expanded: true,
        roles: ['Admin'],
        items: [
          this.menuItem({
            label: 'Διαθεσιμότητα Νοσοκομείου',
            icon: 'fa fa-calendar',
            routerLink: '/hospital-availability/search',
            roles: [
              'HospitalAdmin',
              'PrivateHospitalAdmin',
              'PrivateClinicAdmin',
            ],
          }),
          this.menuItem({
            label: 'Οδηγίες Χρήσης',
            icon: 'pi-question-circle',
            url: `${environment.ROOT_FOLDER}/assets/files/Οδηγίες Χρήσης Εφαρμογής Απογευματινών Χειρουργείων.pdf`,
            roles: ['HospitalAdmin'],
          }),
          this.menuItem({
            label: 'Οδηγίες Χρήσης',
            icon: 'pi-question-circle',
            url: `${environment.ROOT_FOLDER}/assets/files/Οδηγίες Χρήσης Εφαρμογής Ιδ. Κλινικών_v1-21.03.2025.pdf`,
            roles: ['PrivateHospitalAdmin', 'PrivateClinicAdmin'],
          }),
          this.menuItem({
            label: 'Επικοινωνία',
            icon: 'pi-envelope',
            routerLink: '/contact',
            command: () => this.itemClick.emit(),
            roles: [],
          }),
          this.menuItem({
            label: 'Στοιχεία Επικοινωνίας Συμβεβλημένων Ιδιωτικών Κλινικών',
            icon: 'pi-phone',
            url: `${environment.ROOT_FOLDER}/assets/files/Ανακοίνωση Στοιχείων Επικοινωνίας Συμβεβλημένων Ιδιωτικών Κλινικών.pdf`,
            roles: ['Citizen'],
          })
        ],
      },
      // {
      //   label: 'Εργαλεία',
      //   expanded: true,
      //   items: [

      //   ]
      // }
    ];
  }
}
